module.exports = "//a.spikex.com/sigma/frontend-ssr-web-user-center/_next/static/images/sao-light-7cb2e184971607361b41e38ad3034ba5.svg";